import { images } from "../assets/images";
import { deviceTypes } from "../_constants/device-types.constants";

export function getDeviceImage(type, os) {
  let imageSrc;
  switch (type) {
    case deviceTypes.Imagyst:
      imageSrc = images.devices.Imagyst;
      break;
    case deviceTypes.QuickVet:
      imageSrc = images.devices.QuickVet;
      break;
    case deviceTypes.SAUA:
      imageSrc = images.devices.SAUA;
      break;
    case deviceTypes.VS2:
      imageSrc = images.devices.VS2;
      break;
    case deviceTypes.VSPro:
      imageSrc = images.devices.VSPro;
      break;
    case deviceTypes.VetscanSA:
      imageSrc = images.devices.VetscanSA;
      break;
    case deviceTypes.VetscanUA:
      imageSrc = images.devices.VetscanUA;
      break;
    case deviceTypes.HMPLUS:
      imageSrc = images.devices.HMPLUS;
      break;
    case deviceTypes.Vue:
      imageSrc =
        os === "Android" ? images.devices.VueAndroid : images.devices.VueiOS;
      break;
    case deviceTypes.HM5:
      imageSrc = images.devices.HM5;
      break;
    case deviceTypes.iStat:
      imageSrc = images.devices.iStat;
      break;
    default:
      imageSrc = images.devices.Unknown;
  }
  return imageSrc;
}
